/** A teammate with at least one dashboard tab open. */
export interface PresenceEntry {
	userId: string
	lastSeenAt: number
}

export interface PresenceSubscribeData {
	workspaceId: string
	userId: string
	/** IANA zone the member's browser reports, for showing their local time. */
	timeZone?: string
}

export interface PresenceHeartbeatData {
	workspaceId: string
	userId: string
	timeZone?: string
}

export interface MemberLastSeen {
	lastSeenAt: number
	timeZone?: string
}

/** Everyone currently online, broadcast whenever someone arrives or leaves. */
export interface PresenceStateData {
	online: PresenceEntry[]
}

/**
 * A member stays online this long without a beat, so a closed laptop drops off
 * within the window instead of showing a green dot all night.
 */
export const PRESENCE_TTL_SECONDS = 60

/** Comfortably inside the TTL, so one dropped beat never marks someone away. */
export const PRESENCE_HEARTBEAT_MS = 20_000

/** How long "last seen" survives after someone goes offline. */
export const PRESENCE_LAST_SEEN_TTL_SECONDS = 60 * 60 * 24 * 60
